import request from '@/utils/request' //引入封装好的 axios 请求


//申请贷款
export function applyLoan (data = {}) {
    return request({
        url: '/api/loan/apply/operate',
        method: 'post',
        data: data
    })
}

//申请贷款-判断是否授权
export function authStatus (data = {}) {
    return request({
        url: '/api/v1/auth/isAuth',
        method: 'post',
        data: data
    })
}

//申请贷款-判断是否授权
export function queryIsAuthByEnterpriseCode (data = {}) {
    return request({
        url: '/api/v1/user/queryIsAuthByEnterpriseCode',
        method: 'post',
        data: data
    })
}

//一键秒贷列表
export function searchLoanProductList (data = {}) {
    return request({
        url: '/api/loan/apply/searchLoanProductList',
        method: 'post',
        data: data
    })
}

// 随意贷立即申请
export function searchLoanProductDetail (data = {}) {
    return request({
        url: '/api/loan/apply/searchLoanProductDetail',
        method: 'post',
        data: data
    })
}
